import React, { useEffect } from "react";
import PlanUpgrade from "./PlanUpgrade";
import BookingPricing from "./Products/BookingPricing";
import "./Products/BookingDetails.scss";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};
const AllPricingList = () => {
  const AnimatedSection: React.FC<{
    children: React.ReactNode;
    className?: string;
  }> = ({ children, className = "" }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

    useEffect(() => {
      if (inView) {
        controls.start("visible");
      }
    }, [controls, inView]);

    return (
      <motion.section
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={fadeInUp}
        className={className}
      >
        {children}
      </motion.section>
    );
  };
  const PricingHeroSection: React.FC = () => {
    return (
      <section className="hdt-pricing-hero section">
        <div className="container">
          <div className="has-text-centered">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h1 className="title is-1 hdt-pricing-title">
                Simple, Transparent Pricing
              </h1>
              <p className="subtitle is-4 mb-5">
                Choose the perfect plan for your business. No hidden fees, no
                surprises.
              </p>
              <div className="hdt-pricing-badges">
                <span className="tag is-large hdt-badge-primary">
                  💰 Flexible Plans
                </span>
                <span className="tag is-large hdt-badge-success">
                  ✅ No Setup Fee
                </span>
                <span className="tag is-large hdt-badge-info">
                  🎁 Free Trial Available
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    );
  };

 type Service = {
  id: string;
  name: string;
  icon: string;
  description: string;
  color: string;
};

const catView = (category: string, children?: React.ReactNode) => {
  const services: Service[] = [
    {
      id: "booking",
      name: "WhatsApp Ordering (HDT Booking)",
      icon: "💬",
      description:
        "Flagship — orders, kitchen, inventory, vendors & AI reports, all on WhatsApp",
      color: "#128C7E",
    },
    {
      id: "digital-signature",
      name: "Digital Signature",
      icon: "✍️",
      description: "Secure electronic document signing solution",
      color: "#9C27B0",
    },
    {
      id: "ai-extraction",
      name: "AI Data Extraction",
      icon: "🤖",
      description: "Extract data from documents automatically with AI",
      color: "#2196F3",
    },
    {
      id: "chatbot",
      name: "Intelligent Chatbot",
      icon: "💬",
      description: "24/7 AI-powered customer support automation",
      color: "#E91E63",
    },
  ];

  const matchedService = services.find((s) => s.id === category);

  if (!matchedService) {
    return <p className="has-text-grey">No matching service found.</p>;
  }

  return (
    
      <div className="hdt-service-pricing-wrapper">
        <div
          className="hdt-service-header"
          style={{ background: matchedService.color }}
        >
          <div className="hdt-service-icon-large">{matchedService.icon}</div>
          <h3 className="title is-3 has-text-white mb-2">
            {matchedService.name}
          </h3>
          <p className="has-text-white-ter">{matchedService.description}</p>

          {/* ✅ Render any children passed in */}
          {children && <div className="service-children">{children}</div>}
        </div>
      </div>
   
  );
};

  return (
    <>
      <PricingHeroSection />

         <AnimatedSection>
      {catView("booking")}
      <div className="container" style={{ paddingBottom: "3rem" }}>
        <BookingPricing />
      </div>
      </AnimatedSection>

         <AnimatedSection>
      {catView("digital-signature",)}
      <PlanUpgrade category="digisign" />
      </AnimatedSection>
       <AnimatedSection>
       {catView("ai-extraction",)}
       </AnimatedSection>
        <AnimatedSection>
      <PlanUpgrade category="extract" />
      {catView("chatbot",)}
      <PlanUpgrade category="chatbot" />
      </AnimatedSection>
     
      
    </>
  );
};

export default AllPricingList;
